<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb"/>
    <div class="flexBox">
      <text-title :mainTitle="mainTitle" :subheading="subheading" />
      <div class="header-btn-box">
        <a @click="toModifyPage">修改</a>
        <a @click="toBusinessManagement">返回</a>
      </div>
    </div>
    <form>
      <div class="form-line">
        <div class="textBox">
          <span class="line-text">单位名称：</span>
        </div>
        <el-input v-model="formData.enterpriseName" :maxlength="24" size="small" style="width: 280px" disabled/>
      </div>
      <div class="form-line">
        <div class="textBox">
          <span class="line-text">纳税人识别号：</span>
        </div>
        <el-input v-model="formData.taxpayerRegisterNumber" :maxlength="24" size="small" style="width: 280px" disabled/>
      </div>
      <div class="form-line">
        <div class="textBox">
          <span class="line-text">经办人姓名：</span>
        </div>
        <el-input v-model="formData.personName" size="small" style="width: 280px" disabled/>
      </div>
      <div class="form-line">
        <div class="textBox">
          <span class="line-text">经办人手机：</span>
        </div>
        <el-input v-model="formData.phone" size="small" style="width: 280px" disabled/>
      </div>
      <div class="form-line">
        <div class="textBox">
          <span class="line-text">经办人身份证：</span>
        </div>
        <el-input v-model="formData.identityNumber" size="small" style="width: 280px" disabled/>
      </div>
      <div class="form-line">
        <div class="textBox">
          <span class="line-text">申请房型：</span>
        </div>
        <el-select v-model="formData.rentType" placeholder="请选择" size="mini" style="width: 280px" disabled>
          <el-option v-for="item in rentTypeList" :key="item.key" :label="item.label" :value="item.key"></el-option>
        </el-select>
      </div>
      <div class="form-line">
        <div class="textBox">
          <span class="line-text">预入住日期：</span>
        </div>
        <el-date-picker v-model="formData.stayStartTime" type="date" size="small" style="width: 280px" :editable=false value-format="yyyy-MM-dd" placeholder="选择日期" disabled></el-date-picker>
      </div>
      <div class="form-line">
        <div class="textBox">
          <span class="line-text">预租期限：</span>
        </div>
        <el-select v-model="formData.leaseTimeLimit" placeholder="请选择" size="mini" style="width: 280px" disabled>
          <el-option v-for="item in leaseTimeLimitList" :key="item.key" :label="item.label" :value="item.key"></el-option>
        </el-select>
      </div>
      <div class="form-line">
        <div class="textBox">
          <span class="line-text">备注：</span>
        </div>
        <el-input v-model="formData.remarks" size="small" style="width: 280px" disabled/>
      </div>
    </form>
  </div>
</template>

<script>
  import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
  import TextTitle from '../../../components/Text/TextTitle'
  import {api} from '../../api/LeaseManage'
  import {errorHandler} from '../../../utils/errorHandler'

  export default {
    components: {
      TextTitle,
      Breadcrumb},
    name: 'business-current',
    data () {
      return {
        breadcrumb: [{
          value: '资源中心',
          name: 'yq-information'
        }, {
          value: '单位承租'
        }],
        mainTitle: '查看单位',
        subheading: '',
        roomInfoList: [],
        rentTypeList: [
          {key: 0, label: '整租'},
          {key: 1, label: '床位'}
        ],
        leaseTimeLimitList: [
          {key: '一个月', label: '一个月'},
          {key: '三个月', label: '三个月'},
          {key: '半年', label: '半年'},
          {key: '一年', label: '一年'},
          {key: '一年以上', label: '一年以上'},
        ],
        formData: {},
        currentCode: ''
      }
    },
    created () {
      this.currentCode = this.$route.params.id
      this.getEnterpriseLeaseByCode()
    },
    methods: {
      toBusinessManagement () {
        this.$router.push({
          name: 'business-management'
        })
      },
      toModifyPage () {
        this.$router.push({
          path: `/business_modify/${this.currentCode}`
        })
      },
      getEnterpriseLeaseByCode () {
        this.$axios.get(`${api.getEnterpriseLeaseByCode}/${this.currentCode}`, {})
          .then(res => {
            let data = res.data.data
            this.formData = data
          })
          .catch(errorHandler('查询单位失败'))
      },
    }
  }
</script>

<style scoped>
  .flexBox {
    display: flex;
    justify-content: space-between;
  }
  .header-btn-box {
    margin: 20px 0 10px 0;
    color: #337ab7;
    font-size: 14px;
  }
  .header-btn-box a{
    margin-right: 40px;
    cursor: pointer;
  }
  .header-btn-box a:hover{
    color: #00a0e6;
  }

</style>



// WEBPACK FOOTER //
// src/view/ResourceCenter/BusinessManagement/BusinessCurrent.vue